/**
 * @packageDocumentation
 * @module StockChartShared
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {NgbModule, NgbDateParserFormatter, NgbDateAdapter, NgbTimeAdapter} from '@ng-bootstrap/ng-bootstrap';
import { StockChartDateParserService } from './stock-chart-shared-services/stock-chart-date-parser.service';
import { StockChartDateAdapterService } from './stock-chart-shared-services/stock-chart-date-adapter.service';

// might be removed
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClientModule } from '@angular/common/http';
import { SelectComponent } from './stock-chart-shared-components/select/select.component';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule, NgxUiLoaderConfig } from 'ngx-ui-loader';



const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  overlayColor: 'rgba(255,255,255,0.5)',
};
@NgModule({
  declarations: [SelectComponent],
  imports: [
    CommonModule,
    NgbModule,
    ColorPickerModule,
    HighchartsChartModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
  ],
  exports: [
    NgbModule,
    ColorPickerModule,
    FormsModule,
    ReactiveFormsModule,
    HighchartsChartModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule,
    SelectComponent,
    NgxUiLoaderModule
  ],
  providers: [
    {provide: NgbDateParserFormatter, useClass: StockChartDateParserService},
    {provide: NgbDateAdapter, useClass: StockChartDateAdapterService},
  ]
})
export class StockChartSharedModule { }
